module.exports = __webpack_public_path__ + "images/icons/icon-payment-paypal-1f1b057a.svg";